import apiRoutes from "../../Routes/Routes.json";
import HttpClient from "HttpClient";

interface MicrobiologyResultDataRoutes {
  GetAll: string;
  MicrobiologyResultDataBulkValidate: string;
  MicrobiologyResultDataExportToExcelV2: string;
  MicrobiologyResultDataReportTests: string;
  ViewContactInformation: string;
  UpdateLisStatus: string;
  GetResultSummary: string;
  GetOgranismLookup: string;
  GetColonyLookup: string;
  SaveResultSummary: string;
  GetSensitiResultData: string;
  PublishAndValidate: string;
  GetTabHistory: string;
}

const resultDataRoutes = (apiRoutes.MicroBiologyLis as typeof apiRoutes.MicroBiologyLis & {
  ResultData: MicrobiologyResultDataRoutes;
}).ResultData;

export const getAllData = (parameter: any) => {
  return HttpClient().post(
    `${resultDataRoutes.GetAll}`,
    parameter
  );
};

// TODO: Update these routes when backend APIs are ready
export const MicrobiologyResultDataBulkValidate = (parameter: any) => {
  return HttpClient().post(
    `${resultDataRoutes.MicrobiologyResultDataBulkValidate}`,
    parameter
  );
};

export const MicrobiologyResultDataExportToExcelV2 = (parameter: any) => {
  return HttpClient().post(
    `${resultDataRoutes.MicrobiologyResultDataExportToExcelV2}`,
    parameter
  );
};

export const MicrobiologyResultDataReportTest = (parameter: any) => {
  return HttpClient().post(
    `${resultDataRoutes.MicrobiologyResultDataReportTests}`,
    parameter
  );
};

export const ViewContactInformation = (id: number) => {
  return HttpClient().get(
    `${resultDataRoutes.ViewContactInformation}?Id=${id}`
  );
};

export const UpdateLisStatus = (parameter: { reqOrderId: number; tabId: number }) => {
  return HttpClient().post(
    `${resultDataRoutes.UpdateLisStatus}`,
    parameter
  );
};

export const GetResultSummary = (parameter: { requisitionOrderId: number; tabId: number }) => {
  return HttpClient().post(
    `${resultDataRoutes.GetResultSummary}`,
    {requsitionOrderId: parameter.requisitionOrderId, tabId: parameter.tabId}
  );
};

export const GetOgranismLookup = () => {
  return HttpClient().get(
    `${resultDataRoutes.GetOgranismLookup}`
  );
};

export const GetColonyLookup = () => {
  return HttpClient().get(
    `${resultDataRoutes.GetColonyLookup}`
  );
};

// Save result summary (plate/organism details etc.)
export const SaveResultSummary = (parameter: any) => {
  // Use explicit route if present in routes, otherwise fallback to the known API path
  const route = (resultDataRoutes as any).SaveResultSummary || "api/MicrobiologyResultData/SaveResultSummary";
  return HttpClient().post(route, parameter);
};

export const GetSensitiResultData = (parameter: { reqOrderId: number; panelId: number }) => {
  return HttpClient().post(
    `${resultDataRoutes.GetSensitiResultData}`,
    parameter
  );
};

export const PublishAndValidate = (parameter: { requisitionId: number; requisitionOrderId: number }) => {
  return HttpClient().post(
    `${resultDataRoutes.PublishAndValidate}`,
    parameter
  );
};

export const GetTabHistory = (parameter: { reqOrderId: number; tabId: number }) => {
  return HttpClient().post(
    `${resultDataRoutes.GetTabHistory}`,
    parameter
  );
};
